import { contractsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("contract"),
  endpoint: "contracts",
  operations: contractsOps,
  roleView: [ROLE.CONTRACT_VIEW, ROLE.CONTRACT_ADMIN],
  roleAdmin: [ROLE.CONTRACT_ADMIN],
  singularName: (t) => t("Contract"),
  name: (t) => t("Contracts"),
  dependencies: ["user", "customer"],
  syncCustomerFilter: true,
});

export default conf;
